"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

const DISMISSAL_KEY = "cookie-notice-dismissed";

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const t = useTranslations("CookieBanner");

  useEffect(() => {
    if (localStorage.getItem(DISMISSAL_KEY) === "true") return;

    const frame = window.requestAnimationFrame(() => setIsVisible(true));
    return () => window.cancelAnimationFrame(frame);
  }, []);

  function dismiss() {
    localStorage.setItem(DISMISSAL_KEY, "true");
    setIsVisible(false);
  }

  if (!isVisible) return null;

  return (
    <aside
      aria-label="Cookie notice"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-4xl flex-col gap-4 rounded-xl border border-slate-200 bg-white p-4 shadow-lg sm:flex-row sm:items-center sm:justify-between sm:px-6"
    >
      <p className="text-sm leading-6 text-slate-700">
        {t.rich("notice", {
          link: (chunks) => (
            <Link
              href="/cookies"
              className="font-medium text-indigo-600 hover:underline"
            >
              {chunks}
            </Link>
          ),
        })}
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="shrink-0 rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-700"
      >
        {t("dismiss")}
      </button>
    </aside>
  );
}
